import { SUBSCRIBERS_GROWTH_POSTFIX_URL, WEBSITE_URL } from '../constants/APIConstants';
import ky from './kyextended';

const getSubscribers = ({webId, page, page_size, browser, is_test_device, is_active}) => {
    
    const searchParams = new URLSearchParams();
    searchParams.set('page', page);
    searchParams.set('page_size', page_size);
    if(browser) {
        searchParams.set('browser', browser)
    }
    if(is_test_device) {
        searchParams.set('is_test_device', 'True')
    }
    if(is_active) {
        searchParams.set('is_active', 'True')
    }
    if(is_active === false) {
        searchParams.set('is_active', 'False')
    }
    

    return ky.get(`${WEBSITE_URL}${webId}/subscribers/`, {
        searchParams: searchParams,
        headers: {
            Authorization: `Token ${localStorage.getItem('token')}`,
        }
    }).json();
}


const updateSubscribers = (webId, updatedData) =>  ky.patch(`${WEBSITE_URL}${webId}/subscribers/`, {
    json: updatedData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const deleteSubscribers = (webId) =>  ky.delete(`${WEBSITE_URL}${webId}/subscribers/inactive/ `, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const getSubscribersGrowth = ({webId, dates}) => {
    return ky.post(`${WEBSITE_URL}${webId}${SUBSCRIBERS_GROWTH_POSTFIX_URL}`, {
        json: dates,
        headers: {
            Authorization: `Token ${localStorage.getItem('token')}`,
        }
    }).json();}
export {getSubscribers, getSubscribersGrowth, updateSubscribers, deleteSubscribers}